function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDateRange = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon/Date range",
    d: "M43.542 4.583H41.25V2.292a2.292 2.292 0 0 0-4.583 0v2.291H18.333V2.292a2.292 2.292 0 1 0-4.583 0v2.291h-2.292A11.471 11.471 0 0 0 0 16.042v27.5A11.471 11.471 0 0 0 11.458 55h32.084A11.471 11.471 0 0 0 55 43.542v-27.5A11.471 11.471 0 0 0 43.542 4.583zM11.458 9.167h32.084a6.883 6.883 0 0 1 6.875 6.875v2.292H4.583v-2.292a6.883 6.883 0 0 1 6.875-6.875zm32.083 41.25H11.458a6.883 6.883 0 0 1-6.875-6.875V22.917h45.834v20.625a6.883 6.883 0 0 1-6.875 6.875zm0-18.333a2.291 2.291 0 0 1-2.292 2.292H13.75a2.292 2.292 0 1 1 0-4.583h27.5a2.291 2.291 0 0 1 2.292 2.29zM27.5 41.25a2.291 2.291 0 0 1-2.292 2.292H13.75a2.292 2.292 0 1 1 0-4.583h11.458A2.291 2.291 0 0 1 27.5 41.25z",
    transform: "translate(.5 .5)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      strokeMiterlimit: 10,
      opacity: 0.6
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDateRange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon_Date range.af5d2ed5c2884f9e84f278a3b71bcceb.svg";